/*
 * Ryan O'Dowd
 * 2024-01-22
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

// @TODO: yeet unused
const getStyles = ({globalScale, fonts, colors}) => {
  return {
    container: {
      padding: 8,
    },
    editButton: {
      margin: 0,
    },
    errorTextWrapper: {
      paddingTop: 32,
    },
    logoAndNameWrapper: {
      flexGrow: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    schoolLogoImage: {
      display: 'flex',
      width: 60,
      height: 60,
      aspectRatio: 1,
      borderRadius: globalScale * 8,
      borderColor: colors.primaryLight, // @TODO: different if premium?
      borderWidth: globalScale * 2,
      marginRight: globalScale * 8,
    },
    image: {
      display: 'flex',
      width: '100%',
      height: '100%',
      aspectRatio: 1,
      borderRadius: globalScale * 16,
      borderColor: colors.primaryLight, // @TODO: different if premium?
      borderWidth: 4,
    },
    errorText: {
      color: colors.primaryExtraDark,
      margin: 16,
      fontSize: 20,
      textAlign: 'center',
    },
    pageTitle: {
      color: colors.primaryExtraLight,
      fontSize: globalScale * 32,
      fontFamily: fonts.secondaryBold,
    },
    titleWrapper: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: globalScale * 16,
    },
    logoLink: {
      position: 'absolute',
      top: -24, // @TODO: dynamic
      right: 0,
    },
    logo: {
      maxWidth: 200,
      maxHeight: 80,
      right: 0,
    },
    schoolNameText: {
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 20,
    },
    nameAndWebsiteWrapper: {
      flex: 1,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexDirection: 'column',
      height: 60, // @TODO: to match logo height...shouldn't need this, but 100% isn't working
      paddingVertical: globalScale * 2,
    },
    stat: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      cursor: 'info',
    },
    widgetText: {
      color: colors.white,
    },
    trialEndsText: {
      color: colors.complete,
    },
    highlightedText: {
      color: colors.accent,
      fontFamily: fonts.primaryBold,
    },
    websiteText: {
      color: colors.lightGray,
      fontSize: globalScale * 12,
    },
    innerContent: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: globalScale * 4,
    },
    buttons: {
      flexShrink: 1,
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: globalScale * 4,
    },
  };
};

export default getStyles;
